import React from 'react';
import MolLink from '../../Basepage/parts/Menu/MolLink';
import { GetEanSearch } from './Componnents/Ean_search';

export interface SchippingListModel {
  liefer_datum;
  logistiker;
  trackingnummer;
  bestellreferenz;
  mol_auftrag_id;
}

interface SchippingListProp {
  list: {
    orderInfoDetailsTracking: SchippingListModel[];
    eanInfo?: any;
  };
}

export default class SchippingList extends React.Component<SchippingListProp> {
  render(): React.ReactNode {
    let list = this.props.list.orderInfoDetailsTracking ?? [];

    let GetEanSearch_local = GetEanSearch(
      '/konto/shipping',
      this.props.list.eanInfo,
    );
    let GetEanSearch_local_gui = GetEanSearch_local.gui;
    let eanSearchParam = GetEanSearch_local.eanSearchParam;

    return (
      <div id="SchippingList">
        {GetEanSearch_local_gui}
        <table>
          <thead>
            <tr>
              <th>Datum</th>
              <th>Logistiker</th>
              <th>Tracking</th>
              <th>Auftrag ID</th>
              <th>Bestellung ID</th>
            </tr>
          </thead>
          <tbody>
            {list.map((item, index) => {
              let key = 'data_' + index;
              let classNameRow = 'row' + (index % 2 == 1 ? ' mod2' : '');
              let itemLink =
                '/konto/shipping/' +
                item.trackingnummer +
                '/?' +
                eanSearchParam;

              const dateObject = new Date(item.liefer_datum);

              // Datum umformatieren
              const formattedDate_liefer = dateObject.toLocaleDateString(
                'de-DE',
                {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                },
              );

              return (
                <tr id={key} key={key} className={classNameRow}>
                  <td>{formattedDate_liefer}</td>
                  <td>{item.logistiker}</td>
                  <td>
                    <MolLink to={itemLink} href={itemLink}>
                      {item.trackingnummer}
                    </MolLink>
                  </td>
                  <td>
                    <MolLink
                      to={
                        '/konto/mol_orders/' +
                        item.mol_auftrag_id +
                        '/?' +
                        eanSearchParam
                      }
                      href={
                        '/konto/mol_orders/' +
                        item.mol_auftrag_id +
                        '/?' +
                        eanSearchParam
                      }
                    >
                      {item.mol_auftrag_id}
                    </MolLink>
                  </td>
                  <td>{item.bestellreferenz}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
